import React, { useMemo } from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { ButtonMenu } from 'components/atoms';
import { withRouter, NavLink } from 'react-router-dom';

const ButtonMenuLink = ({
  to,
  history: {
    location: { pathname },
  },
  isDisabled,
  isTitle,
  ...props
}) => {
  const isActive = useMemo(() => to === pathname, [pathname, to]);

  const computedModifiers = useMemo(() => {
    let modifiers = ['clearMargin', 'clearHorizontal', 'clean', 'primaryAlt'];
    if (isActive) modifiers = [...modifiers, 'active'];
    if (isDisabled) modifiers = [...modifiers, 'disabled'];
    if (isTitle) modifiers = [...modifiers, 'big'];
    return modifiers;
  }, [isActive, isDisabled, isTitle]);

  return (
    <NavLinkStyled to={to} exact>
      <ButtonMenu
        to={to}
        exact
        modifiers={computedModifiers}
        {...props}
        iconHeight={12}
      />
    </NavLinkStyled>
  );
};

const NavLinkStyled = styled(NavLink)`
  text-decoration: none;
`;

ButtonMenuLink.propTypes = {
  history: PropTypes.shape({
    location: PropTypes.shape({ pathname: PropTypes.string }),
  }).isRequired,
  exact: PropTypes.bool,
  to: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  isTitle: PropTypes.bool,
};

ButtonMenuLink.defaultProps = {
  exact: true,
  isDisabled: false,
  isTitle: false,
};

export default withRouter(ButtonMenuLink);
